import PageTemplate from "../pageTemplate";

export default function Documentation() {
    return (
        <PageTemplate>
            <h1>Documentation</h1>
            <p>Some information about the documentation</p>
        </PageTemplate>
    )
}